import React from "react";
import { MapPin } from "lucide-react";
import { BUSINESS } from "../../lib/config";

export default function ServiceAreas() {
  return (
    <section id="areas" className="py-20 lg:py-24" data-testid="service-areas-section">
      <div className="max-w-7xl mx-auto px-5 lg:px-8">
        <div className="step-num">03 — WHERE WE WORK</div>
        <h2 className="font-display text-4xl sm:text-5xl font-bold mt-3 tracking-tight max-w-2xl">
          Proudly serving South Texas.
        </h2>
        <p className="text-slate-600 mt-4 max-w-2xl">
          Based in Laredo with regular route service across the region. Don't see your city? Call us — we
          likely cover it.
        </p>

        <div className="mt-10 flex flex-wrap gap-3" data-testid="service-areas-list">
          {BUSINESS.areas.map((area) => (
            <div
              key={area}
              className="area-pill flex items-center gap-2"
              data-testid={`area-${area.toLowerCase()}`}
            >
              <MapPin className="w-3.5 h-3.5 text-blue-600" /> {area}, TX
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
